<script>
import PrestacionService from '@/api/PrestacionService';
import AlertComponent from './AlertComponent.vue';
import ImageModal from './ImageModal.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { es } from 'date-fns/locale';
import Loader from './Loader.vue';
import AnularModal from './AnularModal.vue';
import AgregarImagenes from './AgregarImagenes.vue';
import { Role } from '@/_helpers/role';
import NuevoToken from './NuevoToken.vue';
import * as XLSX from 'xlsx';
import * as fs from 'fs';
XLSX.set_fs(fs);
import * as cpexcel from 'xlsx/dist/cpexcel.full.mjs';
XLSX.set_cptable(cpexcel);
import GeneralService from '@/api/GeneralService';
import FacturadorService from '@/api/FacturadorService';
import ModalCambiarEstado from './ModalCambiarEstado.vue';
import ModalModificarEfector from './ModalModificarEfector.vue';
import ModalEnviarARealizar from './ModalEnviarARealizar.vue';
import FacturadoresUsuSelect from './FacturadoresUsuSelect.vue';
import VerObservaciones from './VerObservaciones.vue';
import ModalInformar from './ModalInformar.vue';
import AuthService from '@/api/AuthService';
import PacienteService from '@/api/PacienteService';
import ModalTokenRealizar from './ModalTokenRealizar.vue';
import SelectTipoSolicitud from './SelectTipoSolicitud.vue';
import ConfirmacionDialog from './ConfirmacionDialog.vue';

const generalService = new GeneralService();
const facturadorService = new FacturadorService();
const authService = new AuthService();
const pacienteService = new PacienteService();

/* eslint-disable */
export default {
    name: 'ListadoSolicitudes',
    components: {
        AlertComponent,
        ImageModal,
        Loader,
        AnularModal,
        ConfirmacionDialog,
        AgregarImagenes,
        NuevoToken,
        ModalCambiarEstado,
        ModalModificarEfector,
        ModalEnviarARealizar,
        FacturadoresUsuSelect,
        VerObservaciones,
        ModalInformar,
        ModalTokenRealizar,
        SelectTipoSolicitud
    },
    data : () => ({
        itemsPerPage: 10,
        numPagina: 1,
        totalResultados: 0,
        filtroSinTiposDocumentacion: [],
        listadoSolicitudes: [],
        listadoEnTabla: [],
        facturadorId: '',
        facturadoresId: [],
        facturadoresTotales: [],
        cargandoFacturadores: false,
        prestacionService: new PrestacionService(),
        generandoExcel: false,
        modalEnviarARealizar: false,
        idSolicitudARealizar: null,
        efectorActualSolicitud: '',
        profesionalesFacturador: [],
        cargandoEfector: false,
        dataRealizar: {
            idSolicitud: null,
            NuevoEfectorId: null,
            NuevaEspecialidadEfectorId: null
        },
        headers: [
            { title: "Fecha y hora", key: "fecha" },
            { title: "Tipo", key:"tipo"},
            { title: "Sistema", key:"sistema"},
            { title: "Datos del afiliado", key:"afiliado"},
            { title: "Datos afiliatorios", key:"obraSocial"},
            { title: "Facturador", key: "facturador" },
            { title: "Datos del profesional", key:"efector"},
            { title: "Ingreso", key:"ingreso"},
            { title: "Token afiliado", key:"token"},
            { title: "Copago", key:"copago"},
            { title: "Estado (fecha de cambio)", key:"estado"},
            { title: "", key:"tieneArchivos"},
            { title: "Acciones", key: "detalle" },
        ],
        modal: false,
        date: [],
        fechaDesde: '',
        fechaHasta: '',
        fechaHastaPicker: '',
        fechaDesdePicker: '',
        headers2: [
            { title: "", key: "data-table-expand", sortable: false },
            { title: "Código práctica", key:"prestacioncodigo"},
            { title: "Descripción", key:"prestaciondescripcion"},
            { title: "Cant.", key:"prestacioncantidad"},
            { title: "Diagnóstico", key:"prestacionDiagnostico"},
            { title: "Copago cobrado", key:"copago"},
            { title: "Cobro efector", key:"valorEntidad"},
            { title: "Cobro afiliado", key:"valorAfiliado"},
            { title: "Valor práctica", key:"valorIOMA"},
            { title: "Estado", key:"estado"},
            { title: "Nro. práctica", key:"nroPractica"},
            { title: "Datos del prescriptor", key:"prescriptor"}
        ],
        configuraciones: null,
        // varables para el alert
        alertTitle: '',
        alertText: '',
        alertType:'',
        showAlert:false,
        pdfGenerado: {},
        cargando: false,
        dialog: false,
        dialogConfirm: false,
        mensajeConfirm: '',
        resolverConfirm: null,        
        //variables para filtrado
        modalModificarEfector: false,
        idSolicitudAModificar: null,
        efectorActualSolicitud: '',
        profesionalesFacturador: [],
        cargandoEfector: false,
        dataRealizar: {
            idSolicitud: null,
            NuevoEfectorId: null,
            NuevaEspecialidadEfectorId: null
        },
        search: '',
        estados:[],
        estadosBack: [],
        pedirNuevoToken: false,
        tiposDocumentacion: [],
        cargandoTiposDocumentacion: false,
        cargandoObrasSociales: false,
        obrasSociales: [],
        obraSocialId: null,
        obrasSocialesIds: [],
        tiposSolicitudValues: [],
        estadosColores :[
            {nombre:"Anulada", color:"red", mostrarAut:false}, 
            {nombre:"Pendiente", color:"primary", mostrarAut:false}, 
            {nombre:"TokenVencido", color:"orange", mostrarAut:false}, 
            {nombre:"Observada", color:"orange", mostrarAut:false}, 
            {nombre:"InformeObservado", color:"orange", mostrarAut:true}, 
            {nombre:"Rechazada", color:"red", mostrarAut:false}, 
            {nombre:"EsperandoInforme", color:"primary", mostrarAut:true}, 
            {nombre:"InformePresentado", color:"green", mostrarAut:true}, 
            {nombre:"Facturable", color:"green", mostrarAut:true}, 
            {nombre:"Autorizada", color:"green", mostrarAut:true},
            {nombre:"PorRealizar", color:"primary", mostrarAut:true},
            {nombre:"ParaAuditar", color:"orange", mostrarAut:true},
            {nombre:"ParaAuditarParcial", color:"orange", mostrarAut:true},
            {nombre:"ParcialmenteAutorizada", color:"green", mostrarAut:true},
            {nombre:"Realizada", color:"primary", mostrarAut:true},
            {nombre:"PorRealizarParcial", color:"primary", mostrarAut:true},
            {nombre:"ParcialmenteFacturable", color:"green", mostrarAut:true}
        ],
    }),
    async mounted(){
        await this.getConfiguracionesObrasSociales();
        this.cargandoTiposDocumentacion = true;
        await this.getTiposDocumentacion();
        this.cargandoTiposDocumentacion = false;

        if(!this.esAuditor()){
            this.cargandoObrasSociales = true;
            if (this.esAuditorGeneral()){
                await this.getObrasSocialesTotales();
            } else if (this.esRolAutorizador()){
                await this.getObrasSocialesBandejas();
            } else {
                await this.getObrasSociales();
            }
            this.cargandoObrasSociales = false;
        }

        this.facturadorId = this.$store.getters.getFacturador.id;
        this.fechaHasta = new Date()
        this.fechaHasta.setHours(0, 0, 0, 0);

        this.fechaDesde = new Date();
        this.fechaDesde.setHours(0, 0, 0, 0);

        this.fechaHasta = this.fechaHasta.toISOString();
        this.fechaDesde = this.fechaDesde.toISOString();

        this.fechaDesdePicker = this.fechaDesde;
        this.fechaHastaPicker = this.fechaHasta;

        if(!(this.esRolAutorizador() || this.esAuditor() || this.esAuditorGeneral())){
            this.headers = this.headers.filter(h => h.title != 'Facturador');
        } else {
            this.headers = this.headers.filter(h => h.title != 'Copago');
        }

        if(!this.esAdminFacturador()){
            await this.cargarFacturadores();
        }

        if(!this.esRolAutorizador()){
            this.headers = this.headers.filter(h => h.title != 'Sistema');
        }
        await this.getEstadosBack();
        await this.filtrarPorBack();
    },
    methods: {
        async getListado(fechaDesde, fechaHasta, estados, search, sinDocu,obraSocialId, tiposSolicitudValues, numPagina){
            this.cargando = true;
            this.listadoEnTabla = [];
            this.listadoSolicitudes = [];
            const response = this.esRolAutorizador() ? await this.getSolicitudesPesadas(fechaDesde, fechaHasta, estados, search, sinDocu,this.obrasSocialesIds, tiposSolicitudValues, numPagina) : 
                this.esAuditor() ? await this.prestacionService.getSolicitudes(fechaDesde, fechaHasta, estados, search, sinDocu,[obraSocialId], tiposSolicitudValues, this.facturadoresId, numPagina) :
                this.esAuditorGeneral() ? await this.prestacionService.getSolicitudes(fechaDesde, fechaHasta, estados, search, sinDocu,this.obrasSocialesIds, tiposSolicitudValues, this.facturadoresId, numPagina) :
                await this.prestacionService.getSolicitudesFacturadorNuevo(this.facturadorId, fechaDesde, fechaHasta, estados, search, sinDocu,obraSocialId, tiposSolicitudValues, numPagina);

            if(response && response.status === 200){
                const listado = response.data.solicitudes ? response.data.solicitudes : [];
                this.totalResultados = response.data.cantidadSinPaginado ? response.data.cantidadSinPaginado : 0;
                listado.forEach(element => {
                    let detalleList = [];
                    element.prestaciones.forEach(s =>
                        detalleList.push({
                            id: s.id,
                            prestacioncodigo: s.codigoPractica,
                            prestacioncantidad: s.cantidad,
                            prestaciondescripcion: s.descripcionPractica,
                            prestacionDiagnostico: s.descripcionDiagnostico ?? '-',
                            prescriptor:{
                                matriculaPrescriptor: element.matriculaPrescriptor ?? '-',
                                nombreApellidoPrescriptor: element.nombreApellidoPrescriptor ?? '-',
                                tipoMatriculaPrescriptor: element.tipoMatriculaPrescriptor ?? 'Mat.',
                            },
                            files:s.archivos ? [...s.archivos] : [],
                            copago: s.copago ?? 0,
                            valorIOMA: s.valorIOMA ?? '-',
                            valorEntidad: s.valorEntidad ?? '-',
                            valorAfiliado: s.valorAfiliado ?? '-',
                            estado: s.estado ?? null,
                            nroPractica: s.nroAutorizacion ?? '-',
                            mensajeRechazos: s.mensajeRechazos ?? '',
                        })
                    );
                    this.listadoSolicitudes.push({
                            id: element.id,
                            esBonoAdicional: element.esBonoAdicional,
                            esPracticaPesada: element.esPracticaPesada,
                            copago: element.copago,
                            fecha: element.fecha,
                            files: element.archivos? [...element.archivos] : [],
                            estado: element.estado,
                            fechaCambioEstado: element.fechaCambioEstado ?? '-',
                            nroAutorizacion: element.nroAutorizacion ?? '-',
                            mensajeAutorizacion: element.mensajeUltimaAutorizacion ?? '',
                            tipo: element.prestaciones.some(p => p.codigoPractica == '420101') ? 'Consulta' : 'Práctica',
                            mensajeRechazos: element.mensajeRechazos ?? '',
                            efector:{
                                matriculaEfector:element.matriculaEfector,
                                nombreApellidoEfector:element.nombreApellidoEfector,
                                especialidadEfector:element.especialidadEfector
                            },
                            username: element.username,
                            token: element.estado == 'TokenVencido' || element.validacion.token == null ? '-' : element.validacion.token,
                            afiliado:{
                                afiliadoNombre: element.validacion.nombreApellidoAfiliado,
                                numeroafiliado: element.validacion.nroAfiliado,
                                tipoafiliado: element.validacion.tipoAfiliatorio,
                            },
                            paciente:{
                                direccion: element.paciente.direccion ?? '-',
                                telefono: element.paciente.telefono ?? '-',
                                email: element.paciente.email ?? '-',
                                sexo: element.paciente.sexo ?? '-',
                                tipoDocumento: element.paciente.tipoDocumento ?? '-',
                                numeroDocumento: element.paciente.numeroDocumento ?? '-',
                                apellidoNombre: element.paciente.apellidoNombre ?? '-',
                                planAfiliatorio: element.paciente.planAfiliatorio ?? '-',
                                carnetAfiliatorio: element.paciente.carnetAfiliatorio ?? null,
                                vencimientoCarnet: element.paciente.vencimientoCarnet ?? '-',
                            },
                            obraSocial: {
                                nombre: element.validacion.obraSocial,
                                tipoAfiliatorio: element.validacion.tipoAfiliatorio,
                            },
                            facturador: {
                                nombre: element.facturador.nombre ?? '-',
                                direccion: element.facturador.direccion ?? '-',
                                cuitFacturador: element.facturador.cuitFacturador ?? '-',
                            },
                            ingreso: this.prestacionService.formatTipoIngreso(element.tipoIngreso),
                            tieneArchivos: element.archivos.length > 0 || element.prestaciones.some(p => p.archivos.length > 0), 
                            sistema: element.username == process.env.VUE_APP_USERNAME_KLINICOS ? "Klinicos" : "Prestacional",
                            detalle: detalleList,
                            esUrgente : element.esUrgente,
                            motivoUrgencia: element.motivoUrgencia ?? '',
                            cucUrgencia: element.cucUrgencia ?? '',
                            esVersionNueva: element.esVersionNueva,
                    });
                });
                this.listadoEnTabla = this.listadoSolicitudes.slice();
            } else {
                this.alertTitle= "Error";
                this.alertText= response ? (response.data ? response.data : 'No se pudo obtener el listado de solicitudes') : 'No se pudo obtener el listado de solicitudes';
                this.alertType="error";
                this.showAlert= true;
            }
            this.cargando = false;
        },
        async getSolicitudesPesadas(fechaDesde, fechaHasta, estados, search, sinDocu, idsObrasSociales, tiposSolicitudValues, numPagina){
            const username = this.$store.getters.getUsername;
            return await this.prestacionService.getSolicitudesPesadasFacturador(username, fechaDesde, fechaHasta, estados, search, sinDocu,idsObrasSociales, tiposSolicitudValues, this.facturadoresId, numPagina);
        },
        formatDate(date) {
            let newDate = new Date(date);
            newDate.setHours(0, 0, 0, 0);
            return newDate.toISOString();
        },
        async getTiposDocumentacion(){
            await generalService.GetTiposDocumentacion()
                .then(response => {
                    this.tiposDocumentacion = response.data;
                }) 
                .catch(error => {
                    console.log(error);
                });
        },
        async getEstadosBack(){
            const response =  await this.prestacionService.getEstados();
            if(response && response.status == 200){
                const estados = response.data.map(estado => {
                    return {
                        nombre: estado,
                        valor: estado
                    }
                });
                this.estadosBack = estados;
            }
        },
        getTiposDocParaCarga(tipoSolicitud, nombreObraSocial, esVersionNueva){
            let tipos;
            if (tipoSolicitud === "bono-adicional") {
                tipos = this.tiposDocumentacion.filter(tipo => tipo.valor !== 3 && tipo.valor !== 5);
            } else {
                if (tipoSolicitud === "practica-pesada") {
                    tipos = this.tiposDocumentacion.filter(tipo => tipo.valor !== 3 && tipo.valor !== 4);
                } else {
                    tipos = this.tiposDocumentacion.filter(tipo => tipo.valor !== 3 && tipo.valor !== 4 && tipo.valor !== 5);
                }
            }
            if (this.esIOMA(nombreObraSocial) && esVersionNueva) {
                tipos = tipos.filter(tipo => tipo.valor !== 1);
            }
            return tipos; 
        },
        async getObrasSociales(){
            const facturadorId = this.$store.getters.getFacturador.id;
            const response = await facturadorService.getObrasSociales(facturadorId);
            if(response && response.status === 200){
                this.obrasSociales = response.data;
                const ioma = this.obrasSociales.find(os => os.nombre == 'IOMA');
                if(ioma){
                    this.obrasSociales = this.obrasSociales.filter(os => os.nombre != 'IOMA');
                    this.obrasSociales.unshift(ioma);
                }
            }
        },
        async getConfiguracionesObrasSociales(){
            const response = await pacienteService.getConfiguracionesObrasSociales();
            if(response && response.status === 200){
                this.$store.commit('setConfiguraciones', response.data);
            } else {
                this.alertTitle = "Error";
                this.alertText = "No se pudieron obtener las configuraciones de las obras sociales. " + (response ? response.error : '');
                this.alertType = "error";
                this.showAlert = true;
            }
        },
        async getObrasSocialesTotales(){
            const response = await facturadorService.getObrasSocialesTotales();
            if(response && response.status === 200){
                this.obrasSociales = response.data;
                const ioma = this.obrasSociales.find(os => os.nombre == 'IOMA');
                if(ioma){
                    this.obrasSociales = this.obrasSociales.filter(os => os.nombre != 'IOMA');
                    this.obrasSociales.unshift(ioma);
                }
            }
        },
        async getObrasSocialesBandejas(){
            const response = await facturadorService.getObrasSocialesBandejas();
            if(response && response.status === 200){
                this.obrasSociales = response.data;
                const ioma = this.obrasSociales.find(os => os.nombre == 'IOMA');
                if(ioma){
                    this.obrasSociales = this.obrasSociales.filter(os => os.nombre != 'IOMA');
                    this.obrasSociales.unshift(ioma);
                }
            }
        },
        async cargarFacturadores() {
            this.cargandoFacturadores = true;
            const respUsuario = await authService.buscarUsuario(this.$store.getters.getUsername);
            let usuario = {id:null};
            if(respUsuario && respUsuario.status == 200) {
                usuario = respUsuario.data;
            }
            else {
                this.alertTitle = 'Error';
                this.alertText = 'No se pudo obtener el usuario actual';
                this.alertType = 'error';
                this.showAlert = true;
            }
            const response = this.esAuditor() ? await facturadorService.getFacturadoresPorObraSocial(this.$store.getters.getObraSocial.id) 
            : this.esRolAutorizador() ? await facturadorService.getFacturadoresBandeja(usuario.id)
            : await facturadorService.getFacturadoresTotales();
            if(response && response.status === 200) {
                this.facturadoresTotales = response.data;
            }
            this.cargandoFacturadores = false;
        },
        excedeLimiteDias(fechaDesde, fechaHasta){
            return (fechaDesde < new Date(this.fechaDesde) || fechaHasta < new Date(this.fechaDesde));
        },
        async reiniciarListado(){
            // this.date = [];
            this.estados = [];
            this.search = '';
            this.filtroSinTiposDocumentacion = [];
            this.tiposSolicitudValues = [];
            this.numPagina = 1;
            // this.date = [new Date(this.fechaDesde), new Date(this.fechaHasta)];
            this.fechaDesdePicker = this.fechaDesde;
            this.fechaHastaPicker = this.fechaHasta;
            if(!this.esAuditor()){
                this.obraSocialId = null;
            }
            else {
                this.obraSocialId = this.$store.getters.getObraSocial.id;
            }
            this.obrasSocialesIds = [];
            if (this.$refs.selectTipoSolicitudRef) {
                this.$refs.selectTipoSolicitudRef.limpiarSeleccion();
            }
            await this.getListado(this.fechaDesde, this.fechaHasta, this.estados, '', this.filtroSinTiposDocumentacion, this.obraSocialId, this.tiposSolicitudValues, 0);
        },
        obraSocialRequiereToken(nombreObraSocial){
            const config = this.$store.getters.getConfiguracionesRealizacion(nombreObraSocial);
            return config?.requiereTokenRealizacion ?? false;        
        },
        obraSocialAceptaTokenCero(nombreObraSocial){
            const config = this.$store.getters.getConfiguracionesRealizacion(nombreObraSocial);
            return config?.aceptaTokenCero ?? false;        
        },
        async validarSolicitud(solicitud){
            this.cargando = true;
            const response = await this.prestacionService.autorizarSolicitud(solicitud.id, this.$store.getters.getUsername);
            if(response && response.status === 200){
                this.alertTitle= "Operación realizada con éxito";
                this.alertText= response.data.mensaje;
                this.alertType="success";
                this.showAlert= true;
            } else {
                this.alertTitle= "No pudo autorizarse la solicitud";
                this.alertText= response.data.mensaje;
                this.alertType="error";
                this.showAlert= true;
            }
            await this.filtrarPorBack();
            this.cargando = false;
        },
        async validarSolicitudConTokenNuevo(solicitud){
            this.cargando = true;
            await this.validarSolicitud(solicitud);
            this.cargando = false;
        },
        async generarPDF(idSolicitud){
            this.cargando = true;
            const response = await this.prestacionService.generarPDF(idSolicitud);
            this.cargando = false;
            if(response.status === 200){
                const now = new Date();
                this.pdfGenerado = {
                    dominio: 'General',
                    tipoMime: 'application/pdf',
                    nombre: 'Bono_' + now.toISOString().split('T')[0] + '_' + now.toTimeString().split(' ')[0].replace(/:/g, '-') + '.pdf',
                    contenidoBase64: response.data
                };
                const byteCharacters = atob(this.pdfGenerado.contenidoBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: this.pdfGenerado.tipoMime });

                let blobUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = this.pdfGenerado.nombre;

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(blobUrl);
            } else {
                this.alertTitle= "Error";
                this.alertText= response.data;
                this.alertType="error";
                this.showAlert= true;
            }
        },
        acomodarFechaDesdeHasta(){
            if(this.fechaDesdePicker != '' && this.fechaHastaPicker != ''){
                return [this.fechaDesdePicker, this.fechaHastaPicker];
            }
            else{
                if(this.fechaDesdePicker != ''){
                    return [this.fechaDesdePicker, this.fechaDesdePicker];
                }
                else{
                    return [this.fechaDesde, this.fechaHasta];
                }
            }
        },
        async exportarAExcel(tipoExcel){
            let fechas = this.acomodarFechaDesdeHasta();
            let response;
            this.generandoExcel = true;
            switch (tipoExcel) {
                case 'detallado':
                    response = await generalService.getExcelDetallado(this.facturadorId, fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.obraSocialId, this.tiposSolicitudValues);
                    break;
                case 'valorizado':
                    response = await generalService.getExcelTotalizado(this.facturadorId, fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.obraSocialId, this.tiposSolicitudValues);
                    break;
                case 'auditor':
                    if(this.esAuditorGeneral()){
                        response = await generalService.getExcelAuditor(this.facturadoresId, this.obrasSocialesIds, fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.tiposSolicitudValues);
                    } else {
                        response = await generalService.getExcelAuditor(this.facturadoresId, [this.$store.getters.getObraSocial.id], fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.tiposSolicitudValues);
                    }
                    break;
                default:
                    response = await generalService.getExcel(this.facturadorId, fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.obraSocialId, this.tiposSolicitudValues);
                    break;
            }
            if(response && response.status == 200){
                const excelFile = response.data;
                const byteCharacters = atob(excelFile.contenidoBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], { type: excelFile.tipoMime });

                const blobUrl = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = excelFile.nombre;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(blobUrl);
            }
            this.generandoExcel = false;
        },
        async updateOptions({ page, itemsPerPage, sortBy }){
            if(this.numPagina != page){
                this.numPagina = page;
                await this.filtrarPorBack();
            }
        },
        async filtrarPorBack(){
            let fechas = this.acomodarFechaDesdeHasta();
            if(this.esAuditor()){
                await this.getListado(fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.$store.getters.getObraSocial.id, this.tiposSolicitudValues, this.numPagina - 1);
            } else {
                await this.getListado(fechas[0], fechas[1],this.estados.map(estado => estado.valor), this.search,this.filtroSinTiposDocumentacion, this.obraSocialId, this.tiposSolicitudValues, this.numPagina - 1);
            }
        },
        esHoy(fecha){
            return new Date(fecha).toISOString().split('T')[0] == new Date().toISOString().split('T')[0];
        },
        actualizarFecha(){
            if(this.fechaDesdePicker == null){
                this.fechaDesdePicker = new Date(this.fechaDesde);
            }
            if(this.fechaHastaPicker == null){
                this.fechaHastaPicker = new Date(this.fechaHasta);
            }
        },
        solicitudAnulada(response){
            if(response && response.status === 200){
                this.alertTitle= "Solicitud anulada";
                this.alertText= "La solicitud fue anulada correctamente";
                this.alertType="success";
                this.showAlert= true;
            } else {
                this.alertTitle= "Error";
                this.alertText= response.data;
                this.alertType="error";
                this.showAlert= true;
            }
            this.filtrarPorBack();
        },
        async tokenActualizado(solicitud, response){
            if(response && response.status === 200){
                this.alertTitle= "Token actualizado";
                this.alertText= "El token fue actualizado correctamente";
                this.alertType="success";
                this.showAlert= true;
            } else {
                this.alertTitle= "Error";
                this.alertText= response.data;
                this.alertType="error";
                this.showAlert= true;
            }
            await this.filtrarPorBack();
            await this.validarSolicitudConTokenNuevo(solicitud);
        },
        solicitudRealizada(response){
            if(response && response.status === 200) {
                this.alertTitle = "Solicitud Realizada";
                this.alertText = "Solicitud realizada correctamente.";
                this.alertType = "success";
                this.dialog = false;
            } else {
                this.alertTitle = "Error";
                this.alertText = "No se pudo realizar la solicitud. " + (response ? response.data : '');
                this.alertType = "error";
                this.dialog = false;
            }
            this.showAlert = true;
            this.filtrarPorBack();
        },
        esRolAutorizador(){
            return this.$store.getters.getRole == Role.Autorizador;
        },
        esAuditor(){
            return this.$store.getters.getRole == Role.Auditor;
        },
        esAdminFacturador(){
            return this.$store.getters.getRole == Role.AdministrativoFacturador;
        },
        esAuditorGeneral(){
            return this.$store.getters.getRole == Role.AuditorGeneral;
        },
        esDeKlinicos(solicitud){
            return solicitud.username == process.env.VUE_APP_USERNAME_KLINICOS;
        },
        async cambiarEstado(solicitud, nuevoEstado){
            switch (nuevoEstado.estado){
                case 'Rechazar':
                    const resp = await this.prestacionService.rechazarSolicitud(solicitud.id, this.$store.getters.getUsername, nuevoEstado.motivo);
                    if(resp && resp.status === 200){
                        this.alertTitle= "Solicitud rechazada";
                        this.alertText= "La solicitud fue rechazada correctamente";
                        this.alertType="success";
                        this.showAlert= true;
                    } else {
                        this.alertTitle= "Error";
                        this.alertText= "Ocurrió un error al rechazar la solicitud.";
                        this.alertType="error";
                        this.showAlert= true;
                    }
                    break;
                case 'Autorizar':
                    await this.validarSolicitud(solicitud);
                    break;
                case 'Observar':
                    if(this.esDeKlinicos(solicitud) && !(solicitud.estado == 'Pendiente' || solicitud.estado == 'InformePresentado')){
                        break;
                    }
                    else {
                        const resp2 = await this.prestacionService.observarSolicitud(solicitud.id, this.$store.getters.getUsername, nuevoEstado.motivo);
                        if(resp2 && resp2.status === 200){
                            this.alertTitle= "Solicitud observada";
                            this.alertText= "La solicitud fue observada correctamente";
                            this.alertType="success";
                            this.showAlert= true;
                        } else {
                            this.alertTitle= "Error";
                            this.alertText= "Ocurrió un error al observar la solicitud.";
                            this.alertType="error";
                            this.showAlert= true;
                        }
                    }
                    break;
                case 'Facturable':
                    const resp3 = await this.prestacionService.pasarSolicitudAFacturable(solicitud.id, this.$store.getters.getUsername);
                    if(resp3 && resp3.status === 200){
                        this.alertTitle= "Solicitud marcada como facturable";
                        this.alertText= "La solicitud fue marcada como facturable correctamente";
                        this.alertType="success";
                        this.showAlert= true;
                    } else {
                        this.alertTitle= "Error";
                        this.alertText= "Ocurrió un error al marcar como facturable la solicitud.";
                        this.alertType="error";
                        this.showAlert= true;
                    }
                    break;
            }
            await this.filtrarPorBack();
        },
        calcularEstados(solicitud){
            switch (solicitud.estado){
                case 'Pendiente':
                    return ['Autorizar','Rechazar','Observar'];
                case 'InformePresentado':
                    return ['Rechazar','Observar','Facturable'];
                default:
                    return [];
            }
        },
        puedeAnular(solicitud){
            const hoy = new Date().toISOString().split('T')[0];
            const fechaSolicitud = new Date(solicitud.fecha).toISOString().split('T')[0];
            return !(this.esAuditor() || this.esRolAutorizador() || this.esAuditorGeneral()) &&
                    !(solicitud.estado == 'Anulada' || solicitud.estado == 'Rechazada') &&
                    !((solicitud.estado == 'Facturable' || solicitud.estado == 'ParcialmenteFacturable') && fechaSolicitud != hoy);
        },
        mostrarConfirmacion(mensaje) {
            this.mensajeConfirm = mensaje;
            this.dialogConfirm = true;
            return new Promise((resolve) => {
                this.resolverConfirm = resolve;
            });
        },
        confirmar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(true);
            this.resolverConfirm = null;
        },
        cancelar() {
            this.dialogConfirm = false;
            if (this.resolverConfirm) this.resolverConfirm(false);
        },
        estaObservada(solicitud){
            return solicitud.estado == 'Observada';
        },
        esIOMA(nombreObraSocial){
            return nombreObraSocial == 'IOMA';
        },
        enviarAuditoriaIOMA(idSolicitud){
            const mensaje = "La solicitud será enviada a auditoría de IOMA a la espera de que un auditor la revise. Recuerde revisar las observaciones en las acciones de la solicitud.";
            const confirmacion = this.mostrarConfirmacion(mensaje);
            confirmacion.then(confirmado => {
                if (confirmado) {                    
                    const response = this.prestacionService.enviarAuditoriaIOMA(idSolicitud);
                    response.then(response => {
                        if(response && response.status === 200){
                            this.alertTitle= "Auditoría enviada";
                            this.alertText= "La solicitud fue enviada a auditoría de IOMA. ";
                            this.alertType= "success";
                            this.showAlert= true;
                        } else {
                            this.alertTitle= "Error!";
                            this.alertText= "Error al enviar la auditoría al servicio de IOMA: " + response.data;
                            this.alertType="error";
                            this.showAlert= true;
                        };
                    });
                }
            });
        },
        modificarEfector(solicitud){
            // Guardar datos de la solicitud
            this.idSolicitudAModificar = solicitud.id;
            this.efectorActualSolicitud = solicitud.efector ? 
                `Profesional: ${solicitud.efector.matriculaEfector} - ${solicitud.efector.nombreApellidoEfector} - Especialidad: ${solicitud.efector.especialidadEfector} ` :
                'No especificado';
            if (this.profesionalesFacturador.length === 0) {
                this.cargarProfesionales();
            }
            this.modalModificarEfector = true;
        },
        enviarARealizarIOMA(solicitud){
            // Guardar datos de la solicitud
            this.idSolicitudARealizar = solicitud.id;
            this.efectorActualSolicitud = solicitud.efector ? 
                `Profesional: ${solicitud.efector.matriculaEfector} - ${solicitud.efector.nombreApellidoEfector} - Especialidad: ${solicitud.efector.especialidadEfector} ` :
                'No especificado';
            if (this.profesionalesFacturador.length === 0) {
                this.cargarProfesionales();
            }
            this.modalEnviarARealizar = true;
        },        
        async cargarProfesionales() {
            this.cargandoEfector = true;
            try {
                // Obtener el ID del facturador actual
                const facturadorId = this.facturadorId || this.$store.getters.getFacturador?.id;
                
                if (!facturadorId) {
                    console.error('No se encontró el ID del facturador');
                    this.alertTitle = 'Error';
                    this.alertText = 'No se pudo obtener el facturador actual';
                    this.alertType = 'error';
                    this.showAlert = true;
                    return;
                }
                
                // Llamar al servicio para obtener los profesionales
                const response = await facturadorService.getProfesionalesSinExpiracionFacturador(facturadorId);//getProfesionalesFacturador(facturadorId);
                if (response && response.status === 200) {
                    this.profesionalesFacturador = response.data;
                } else {
                    console.error('Error al cargar profesionales:', response);
                    this.alertTitle = 'Error';
                    this.alertText = 'No se pudieron cargar los profesionales';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
            } catch (error) {
                console.error('Error al cargar profesionales:', error);
                this.alertTitle = 'Error';
                this.alertText = 'Error al cargar los profesionales: ' + error.message;
                this.alertType = 'error';
                this.showAlert = true;
            } finally {
                this.cargandoEfector = false;
            }
        },
        handleModificarEfector(datos) {
            this.dataRealizar = {
                idSolicitud: datos.idSolicitud,
                NuevoEfectorId: datos.nuevoEfector.idProfesional,
                NuevaEspecialidadEfectorId: datos.nuevoEfector.idEspecialidad
            };
            const response = this.prestacionService.modificarEfector(this.dataRealizar.idSolicitud, this.dataRealizar.NuevoEfectorId, this.dataRealizar.NuevaEspecialidadEfectorId);
            response.then(response => {
                if(response && response.status === 200){
                    this.alertTitle = "Efector Modificado";
                    this.alertText = "La solicitud se guardó correctamente con el nuevo efector.";
                    this.alertType = "success";
                    this.showAlert = true;
                } else {
                    this.alertTitle = "Error!";
                    this.alertText = "Error al guardar el nuevo efector: " + response.data;
                    this.alertType = "error";
                    this.showAlert = true;
                }
                this.modalModificarEfector = false;
                this.filtrarPorBack();
            }).catch(error => {
                this.alertTitle = "Error!";
                this.alertText = "Error al guardar el nuevo efector: " + error.message;
                this.alertType = "error";
                this.showAlert = true;
                this.modalModificarEfector = false;
            });
        },
        handleEnviarARealizar(datos) {
            if (datos.mantenerEfector) {
                // Solo enviar el ID de la solicitud
                this.dataRealizar = {
                    idSolicitud: datos.idSolicitud
                };
            } else {
                // Enviar con nuevo efector
                this.dataRealizar = {
                    idSolicitud: datos.idSolicitud,
                    NuevoEfectorId: datos.nuevoEfector.idProfesional,
                    NuevaEspecialidadEfectorId: datos.nuevoEfector.idEspecialidad
                };
            }
            const response = this.prestacionService.enviarARealizarIOMA(this.dataRealizar.idSolicitud, this.dataRealizar.NuevoEfectorId, this.dataRealizar.NuevaEspecialidadEfectorId);
            response.then(response => {
                if(response && response.status === 200){
                    this.alertTitle = "Solicitud enviada a realizar";
                    this.alertText = datos.mantenerEfector ? 
                        "La solicitud fue enviada a realizar correctamente con el efector actual." :
                        "La solicitud fue enviada a realizar correctamente con el nuevo efector.";
                    this.alertType = "success";
                    this.showAlert = true;
                } else {
                    this.alertTitle = "Error!";
                    this.alertText = "Error al enviar la solicitud a realizar: " + response.data;
                    this.alertType = "error";
                    this.showAlert = true;
                }
                this.modalEnviarARealizar = false;
                this.filtrarPorBack();
            }).catch(error => {
                this.alertTitle = "Error!";
                this.alertText = "Error al enviar la solicitud a realizar: " + error.message;
                this.alertType = "error";
                this.showAlert = true;
                this.modalEnviarARealizar = false;
            });
        },           
        // Funciones para archivos
        puedeAdjuntarArchivos(solicitud){
            return !(this.esAuditor() || this.esRolAutorizador() || this.esAuditorGeneral()) &&
                !(solicitud.estado == 'Anulada' || solicitud.estado == 'Rechazada');
        },
        archivosAgregados(response){
            if(response && response.status === 200){
                this.alertTitle = 'Archivo agregado correctamente';
                this.alertText = 'Podrá visualizar el archivo en el detalle de la solicitud correspondiente';
                this.alertType = 'success';
                this.showAlert = true;
            } else if (response && response.data.includes('No se puede adjuntar archivos a solicitudes en estado')) {
                this.alertTitle = 'Advertencia';
                this.alertText = response.data;
                this.alertType = 'warning';
                this.showAlert = true;
            } else {
                this.alertTitle = 'Error';
                this.alertText = response.data;
                this.alertType = 'error';
                this.showAlert = true;
            }
            this.filtrarPorBack();
        },
        eliminarArchivo(response){
            if(response && response.status === 200){
                this.alertTitle = 'Archivo eliminado';
                this.alertText = 'El archivo se ha eliminado correctamente';
                this.alertType = 'success';
                this.showAlert = true;
            }
            else{
                this.alertTitle = 'Error';
                this.alertText = response.data;
                this.alertType = 'error';
                this.showAlert = true;
            }
            this.filtrarPorBack();
        },       
        archivoCargadoHandler(response){
            if(response && response.status === 200){
                this.alertTitle = 'Exito al subir el archivo!';
                this.alertText = 'Archivo cargado con exito en el sistema de IOMA';
                this.alertType = 'success';
                this.showAlert = true;
            }
            else{
                this.alertTitle = 'Error';
                this.alertText = response.data;
                this.alertType = 'error';
                this.showAlert = true;
            }
            this.filtrarPorBack();
        },
        puedeValorizar(detalle){
            let aux = true;
            detalle.forEach(d => {
                if(d.valorAfiliado == '-' || d.valorEntidad == '-' || d.valorIOMA == '-'){
                    aux = false;
                }
            });
            return aux;
        },
        getTextoAutorizacion(item) {
            const estadoConfig = this.estadosColores.find(e => e.nombre === item.estado);
            
            if (!item.nroAutorizacion || item.nroAutorizacion === '-' || !estadoConfig?.mostrarAut) {
                return '';
            }
            
            const esParaAuditar = item.estado === 'ParaAuditar' || item.estado === 'ParaAuditarParcial';
            const prefijo = esParaAuditar ? 'Nro prestación: ' : 'Nro autorización: ';
            
            return prefijo + item.nroAutorizacion;
        },
        obtenerValorizacionIOMA(idSolicitud){
            this.cargando = true;
            const response = this.prestacionService.obtenerValorizacionIOMA(idSolicitud);
            response.then(response => {
                this.cargando = false;
                if(response && response.status === 200){
                    this.alertTitle= "Valores actualizados";
                    this.alertText= "Los valores fueron actualizados correctamente, abra nuevamente el detalle de la solicitud para visualizar los cambios.";
                    this.alertType="success";
                    this.showAlert= true;
                } else {
                    this.alertTitle= "Error";
                    this.alertText= response.data;
                    this.alertType="error";
                    this.showAlert= true;
                }
                this.filtrarPorBack();
            });
        },
        mostrarErrorClip(solicitud){
            const aux = ( 
                this.esIOMA(solicitud.nombreObraSocial) &&
                solicitud.esVersionNueva && 
                solicitud.files.some(a => !a.cargadoEnIOMA) && 
                !(
                solicitud.estado == 'Anulada' || 
                solicitud.estado == 'Rechazada' || 
                (solicitud.estado == 'Pendiente' && !solicitud.esPracticaPesada) || 
                solicitud.estado == 'Facturable' || 
                solicitud.estado == 'ParcialmenteFacturable' || 
                solicitud.estado == 'PorRealizar' || 
                solicitud.estado == 'PorRealizarParcial'
                )
            );
            return aux;
        },
        actualizar(){
            this.filtrarPorBack();
        },
        esRealizable(detalle){
            return detalle.some(p => p.estado === 'PorRealizar' || p.estado === null);
        },
    }
}
</script>

<style src="../assets/general.css"></style>

<template>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    />
    <ConfirmacionDialog
        :dialogConfirm="dialogConfirm"
        :mensajeConfirm="mensajeConfirm"
        @confirmar="confirmar"
        @cancelar="cancelar"
    />    
    <v-container>
        <v-row>
            <v-col cols="12" md="2" v-if="esAuditor()">
                <v-btn id="boton-verde" min-width="220" 
                @click="esAuditor() ? this.$router.push('/auditoria/eleccion-os') : this.$router.push('')"
                block><v-icon icon="mdi mdi-arrow-left"></v-icon></v-btn>
            </v-col>
        </v-row>
    </v-container>
    <v-container style="background-color: white;" class="borde-gris">
        <v-row justify="center" align="center">
            <v-col cols="12" md="9">
                <v-row justify="center" align="center">
                    <v-col cols="12" :md="4">
                        <p>Fecha desde:</p>
                        <VueDatePicker
                            v-model="fechaDesdePicker"
                            :enableTimePicker="false"
                            :auto-apply="true"
                            :max-date="new Date()"
                            :format-locale="es"
                            :format="date => date ? date.getDate()+ '/' + (date.getMonth() + 1) + '/' + date.getFullYear() : ''"
                            cancel-text="Cancelar"
                            select-text="Aplicar"
                            :teleport="true"
                            :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
                            @update:modelValue="actualizarFecha"
                        />
                    </v-col>
                    <v-col cols="12" :md="4">
                        <p>Fecha hasta:</p>
                        <VueDatePicker
                            v-model="fechaHastaPicker"
                            :enableTimePicker="false"
                            :auto-apply="true"
                            :max-date="new Date()"
                            :min-date="fechaDesdePicker"
                            :format-locale="es"
                            :format="date => date ? date.getDate()+ '/' + (date.getMonth() + 1) + '/' + date.getFullYear() : ''"
                            cancel-text="Cancelar"
                            select-text="Aplicar"
                            :teleport="true"
                            :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
                            @update:modelValue="actualizarFecha"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <p>Filtrar por estado/s:</p>
                        <v-select
                            v-model="estados"
                            clearable
                            chips
                            variant="solo"
                            return-object
                            :items="estadosBack"
                            item-title="nombre"
                            density="compact"
                            multiple
                            hide-details
                            label="Estado"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row class="d-flex align-center">
                    <v-col cols="12" md="4">
                        <p>Texto:</p>
                        <v-text-field
                            v-model="search"
                            @update:model-value="filtradoGeneral"
                            label="Buscar"
                            prepend-inner-icon="mdi-magnify"
                            variant="solo-filled"
                            density="compact"
                            hide-details
                            single-line
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" v-if="!(esAuditorGeneral() || esRolAutorizador())">
                        <SelectTipoSolicitud
                            ref="selectTipoSolicitudRef"
                            @selectTiposSolicitudes="this.tiposSolicitudValues = $event"
                        >
                        </SelectTipoSolicitud>
                    </v-col>
                    <v-col cols="12" md="4" v-if="(esAuditorGeneral() || esRolAutorizador())">
                        <div>
                            <p>Filtrar por obras sociales:</p>
                            <v-autocomplete
                                v-model="obrasSocialesIds"
                                clearable
                                variant="solo"
                                :items="obrasSociales"
                                item-title="nombre"
                                item-value="id"
                                density="compact"
                                multiple
                                hide-details
                                :loading="cargandoObrasSociales"
                                label="Obra social"
                            >
                                <template v-slot:item="{ props, item }">
                                    <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                                </template>  
                            </v-autocomplete>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4" v-if="esAdminFacturador()">
                        <p>Filtrar por obra social:</p>
                        <v-autocomplete
                            v-model="obraSocialId"
                            clearable
                            variant="solo"
                            :items="obrasSociales"
                            item-title="nombre"
                            item-value="id"
                            density="compact"
                            hide-details
                            :loading="cargandoObrasSociales"
                            label="Obra social"
                        >
                            <template v-slot:item="{ props, item }">
                                <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                            </template>  
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4" v-else>
                        <p>Filtrar por facturadores:</p>
                        <v-autocomplete
                            v-model="facturadoresId"
                            :items="facturadoresTotales"
                            item-title="nombre"
                            item-value="id"
                            label="Facturador"
                            variant="solo"
                            density="compact"
                            hide-details
                            clearable
                            multiple
                            chips
                            :menu-props="{ 
                                width: '1000px'
                            }"
                        >
                            <template v-slot:item="{ props, item }">
                                <v-list-item
                                    v-bind="props"
                                    :subtitle="item.raw.direccion"
                                />
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="3">
                <v-row justify="center" align="center">
                    <v-col cols="12" md="12">
                        <p>Buscar solicitudes sin:</p>
                        <v-select
                            v-model="filtroSinTiposDocumentacion"
                            clearable
                            chips
                            variant="solo"
                            :items="tiposDocumentacion"
                            item-title="nombre"
                            item-value="valor"
                            density="compact"
                            multiple
                            hide-details
                            :loading="cargandoTiposDocumentacion"
                            label="Tipo de documentación"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row class="d-flex align-center mt-10">
                    <v-col cols="12" md="6">
                        <v-btn block id="boton-verde" @click="filtrarPorBack()"><v-icon class="mdi mdi-magnify"></v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn block id="boton-verde" @click="reiniciarListado()">Limpiar</v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
    <v-container style="background-color: white;" class="borde-gris mt-4">
    <v-card>
        <v-card-title class="align-center">
            <v-row justify="center" align="center">
                <v-col cols="12" md="6" class="d-flex flex-column mt-0">
                    <v-row class="d-flex flex-column">
                        <div class="d-flex align-center">
                            <v-icon class="mr-2">mdi-call-made</v-icon>
                            <h3 class="mr-4">Solicitudes cargadas</h3>
                            <!-- <b v-if="esAuditor()"> Facturador: {{ this.$store.getters.getFacturador.nombre }}</b> -->
                        </div>
                        <h4 v-if="fechaDesdePicker && fechaHastaPicker && esHoy(fechaDesdePicker) && esHoy(fechaHastaPicker)" class="mt-2 my-text-black">(Las del día de hoy, si quiere ver anteriores puede filtrar por fechas)</h4>
                        <!-- date && date[0] && date[1] && esHoy(date[0]) && esHoy(date[1]) -->
                    </v-row>
                </v-col>
                <!-- <v-spacer v-if="$vuetify.display.mdAndUp"></v-spacer> -->
                <v-col cols="12" md="6">
                    <v-row justify="end" align="end" v-if="!esRolAutorizador()">
                        <v-col cols="12" md="4" class="d-flex justify-end align-end" v-if="!(esAuditorGeneral() || esAuditor())">
                            <p></p>
                            <v-btn id="boton-verde" :disabled="generandoExcel" @click="exportarAExcel('original')">
                                <v-icon>mdi-microsoft-excel</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex justify-end align-end">
                            <p></p>
                            <v-btn id="boton-verde" :disabled="generandoExcel" @click="(esAuditorGeneral() || esAuditor()) ? exportarAExcel('auditor') : exportarAExcel('detallado')">
                                Detallado
                                <v-icon>mdi-microsoft-excel</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex justify-end align-end"  v-if="!(esAuditorGeneral() || esAuditor())">
                            <p></p>
                            <v-btn id="boton-verde" :disabled="generandoExcel" @click="exportarAExcel('valorizado')">
                                Valorizado
                                <v-icon>mdi-microsoft-excel</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-title>

        <v-divider></v-divider>
        <v-data-table-server
            v-model:items-per-page="itemsPerPage"
            :headers="headers"
            :items="listadoEnTabla"
            :items-length="totalResultados"
            :loading="cargando"
            @update:options="updateOptions"
            :no-data-text="'No hay solicitudes realizadas'"
            :no-data-text-style="{'font-size': '2xl'}"
            :loading-text="'Cargando...'"
            :items-per-page-options="[10]"
            disable-sort
        >
            <template v-slot:item.fecha="{ item }">
                {{
                    (() => {
                        const date = new Date(item.fecha);
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        const hora = date.getHours();
                        const minutos = date.getMinutes();
                        return `${day}/${month}/${year} ${hora.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
                    })()
                }}
            </template>

            <template v-slot:item.tipo="{ item }">
                <v-chip
                    style="text-align: center;"
                    v-if="item.esUrgente"
                    color="red"
                >
                    Urgente 
                    <v-icon>mdi mdi-alert</v-icon>
                </v-chip>
                <p v-if="item.esPracticaPesada" style="text-align: center;">Práctica pesada</p>
                <p v-else>{{ item.tipo }}</p><p v-if="item.esBonoAdicional">(Bono adicional)</p>
            </template>

            <template v-slot:item.sistema="{ item }">
                <v-chip v-if="item.sistema == 'Klinicos'" color="primary">Klinicos</v-chip>
                <v-chip v-else color="green">Prestacional</v-chip>
            </template>

            <template v-slot:item.afiliado="{ item }">
                <p>{{ item.paciente.apellidoNombre }}</p>
                <p>{{ item.afiliado.numeroafiliado }}</p>
                <p class="font-weight-light">{{ item.afiliado.tipoafiliado }}</p>
            </template>

            <template v-slot:item.obraSocial="{ item }">
                <p>{{ item.obraSocial.nombre }}</p>
                <p>{{ item.obraSocial.tipoAfiliatorio }}</p>
            </template>
            
            <template v-slot:item.facturador="{ item }" v-if="esRolAutorizador() || esAuditor() || esAuditorGeneral()">
                <p>{{ item.facturador.nombre }}</p>
                <h5>{{ item.facturador.direccion }}</h5>
                <p class="font-weight-light">Cuit: {{ item.facturador.cuitFacturador }}</p>
            </template>

            <template v-slot:item.efector="{ item }">
                <p>{{ item.efector.nombreApellidoEfector }}</p>
                <p>{{ item.efector.especialidadEfector }}</p>
                <p class="font-weight-light">Mat. {{ item.efector.matriculaEfector }}</p>
            </template>

            <template v-slot:item.copago="{ item }" v-if="!(esRolAutorizador() || esAuditor() || esAuditorGeneral())">
                <p>${{ item.copago }}</p>
            </template>

            <template v-slot:item.estado="{ item }">
                <!--  v-if="item.estado != 'Autorizada'" -->
                <div>
                    <v-chip
                        :color=" estadosColores.find(e => e.nombre == item.estado) ? estadosColores.find(e => e.nombre == item.estado).color : 'grey' "
                    >
                        {{ this.estadosColores.find(e => e.nombre == item.estado) ? (this.estadosColores.find(e => e.nombre == item.estado).nombre != 'PorRealizar' ? this.estadosColores.find(e => e.nombre == item.estado).nombre : 'Aut. p/ realizar') : ' - '  }}
                    </v-chip>
                    <p>{{ getTextoAutorizacion(item) }}</p>
                    <p v-if="item.fechaCambioEstado != '-'" class="font-weight-light">
                        {{
                            (() => {
                                const date = new Date(item.fechaCambioEstado);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                const hora = date.getHours();
                                const minutos = date.getMinutes();
                                return `${day}/${month}/${year} ${hora.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
                            })()
                        }}
                    </p>
                </div>
                <!-- <v-chip
                    v-else
                    color="green"
                >
                    {{ item.nroAutorizacion ? item.nroAutorizacion : 'Autorizada' }}
                </v-chip> -->
            </template>
            <template v-slot:item.tieneArchivos="{ item }">
                <ImageModal
                    v-if="item.files.length > 0 || item.detalle.some(d => d.files.length > 0)"
                    :archivos="item.files"
                    :detalle="item.detalle"
                    :idSolicitud="item.id"
                    :errorCargaArchivo="mostrarErrorClip(item)"
                    :esPracticaPesada="item.esPracticaPesada"
                    :tiposDocumentacion="tiposDocumentacion"
                    :mostrarAcciones = "!(esAuditor() || esRolAutorizador() || esAuditorGeneral())"
                    :estadoSolicitud="item.estado"
                    @archivo-eliminado="eliminarArchivo($event)"
                    @archivo-cargado="archivoCargadoHandler($event)"
                ></ImageModal>
            </template>
            <template v-slot:item.detalle="{ item }">
                <v-menu
                    open-on-hover
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                        id="boton-verde"
                        v-bind="props"
                        :disabled="cargando"
                        :loading="cargando"
                        >
                        <v-icon>mdi mdi-arrow-right</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item v-if="(item.estado == 'Pendiente' && !(esAuditor() || esRolAutorizador() || esAuditorGeneral()) && !item.esPracticaPesada) || (item.esVersionNueva && item.esPracticaPesada && item.estado == 'Pendiente' && esAdminFacturador())" @click="validarSolicitud(item)" style="background-color: #C8E6C9;">
                            <v-list-item-title style="color: #4CAF50;">
                                Autorizar
                            </v-list-item-title>
                        </v-list-item>
                        <NuevoToken
                            v-if="item.estado == 'TokenVencido' && !(esAuditor() || esRolAutorizador() || esAuditorGeneral())"
                            :datosContacto="{email:item.paciente.email, telefono:item.paciente.telefono}"
                            :username="item.username"
                            :idSolicitud="item.id"
                            @tokenActualizado="tokenActualizado(item, $event)"
                        ></NuevoToken>
                        <AnularModal
                            v-if="puedeAnular(item)"
                            :solicitudId="item.id"
                            @solicitud-anulada="solicitudAnulada"
                        ></AnularModal>
                        <v-list-item v-if="(esIOMA(item.obraSocial.nombre) && item.estado == 'Observada')" @click="enviarAuditoriaIOMA(item.id)" style="background-color:#C4CBFF;">
                            <v-list-item-title style="color: #3848C7">
                                Enviar a auditoría (IOMA)
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="esIOMA(item.obraSocial.nombre) && esAdminFacturador() && esRealizable(item.detalle) && item.esVersionNueva" @click="enviarARealizarIOMA(item)" style="background-color:#C4CBFF;">
                            <v-list-item-title style="color: #3848C7">
                                Marcar como realizada
                                <v-icon>mdi mdi-arrow-right</v-icon>
                            </v-list-item-title>
                        </v-list-item>   
                        <v-list-item v-if="esAdminFacturador() && item.esPracticaPesada && !item.esVersionNueva && !(item.estado === 'Anulada' || item.estado === 'Rechazada' || item.estado === 'Facturable' || item.estado === 'ParaAuditar' || item.estado === 'ParaAuditarParcial' || item.estado === 'ParcialmenteFacturable')" @click="modificarEfector(item)" style="background-color:#C4CBFF;">
                            <v-list-item-title style="color: #3848C7">
                                Modificar Efector
                                <v-icon>mdi mdi-arrow-right</v-icon>
                            </v-list-item-title>
                        </v-list-item>  
                        <ModalTokenRealizar
                            v-if="obraSocialRequiereToken(item.obraSocial.nombre) && esAdminFacturador() && !item.esVersionNueva && item.estado === 'PorRealizar'"
                            :idSolicitud="item.id"
                            @solicitud-realizada="solicitudRealizada"
                            :permiteCero="obraSocialAceptaTokenCero(item.obraSocial.nombre)"
                        ></ModalTokenRealizar>  
                        <ModalInformar
                            v-if="esIOMA(item.obraSocial.nombre) && esAdminFacturador() && item.esVersionNueva && item.estado === 'EsperandoInforme'"
                            :idSolicitud="item.id"
                            :practicas="item.detalle"
                            :solicitud="item"
                            @actualizar="actualizar"
                        ></ModalInformar>                                                                   
                        <VerObservaciones
                            :idSolicitud="item.id"
                            :motivoRechazo="item.estado == 'Rechazada' ? item.mensajeAutorizacion : ''"
                        ></VerObservaciones>
                        <ModalCambiarEstado
                            v-if="!item.esVersionNueva && (item.estado === 'InformePresentado' || item.estado === 'Pendiente') && esRolAutorizador()"
                            @cambiar-estado="cambiarEstado(item, $event)"
                            :estados="calcularEstados(item)"
                            :sistema="item.sistema"
                            :numeroAfiliado="item.afiliado.numeroafiliado"
                            :obraSocial="item.obraSocial.nombre"
                            :practicasIds="item.detalle.map(p => p.id)"
                        ></ModalCambiarEstado>
                        <v-dialog
                            transition="dialog-top-transition"
                            width="auto"
                        >
                            <template v-slot:activator="{ props: activatorProps }">
                                <v-list-item v-bind="activatorProps">
                                    <v-list-item-title>
                                        <v-icon>mdi mdi-clipboard-text</v-icon>
                                        Detalle solicitud
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                            <template v-slot:default="{ isActive }">
                                <v-card min-width="600">
                                    <v-toolbar title="Detalle de la solicitud" class="modal-header"></v-toolbar>                                        
                                    <v-alert
                                        v-if="(item.mensajeAutorizacion != '' && (item.estado == 'Pendiente' || item.estado == 'TokenVencido' || item.estado == 'Observada') || (item.mensajeRechazos != '' && (item.estado == 'Rechazada' || item.detalle.some(d => d.estado == 'Rechazada'))))"
                                        :text="item.mensajeRechazos != '' ? item.mensajeRechazos : item.mensajeAutorizacion"
                                        :title="item.estado == 'Rechazada' ? 'Solicitud rechazada' : 'Solicitud no autorizada'"
                                        type="error"
                                        :color="item.estado == 'Rechazada' ? 'red' : 'primary'"
                                        variant="tonal"
                                        density="compact"
                                        class="mb-2"
                                    ></v-alert>
                                    <v-alert
                                        v-if="item.mensajeAutorizacion != '' && item.estado == 'Autorizada'"
                                        :text="item.mensajeAutorizacion"                                        
                                        title="Solicitud autorizada"
                                        type="success"
                                        variant="tonal"
                                        density="compact"
                                        class="mb-2"                                        
                                    ></v-alert>
                                    <v-alert
                                        v-if="item.esUrgente"
                                        title="Solicitud urgente"
                                        :color="'red'"
                                        variant="tonal"
                                        density="compact"
                                        class="mb-2"                                        
                                    >
                                        <p><strong>CUC:</strong> {{ item.cucUrgencia }}</p>
                                        <p><strong>Motivo de la urgencia:</strong> {{ item.motivoUrgencia }}</p>
                                    </v-alert>
                                    <v-data-table 
                                        :headers="headers2"
                                        :items="item.detalle"
                                        hide-default-footer
                                        disable-sort="true"
                                        height="400"
                                        item-value="id"
                                        :show-expand="esIOMA(item.obraSocial.nombre) && item.detalle.some(d => d.mensajeRechazos && d.mensajeRechazos.trim() != '')"
                                    >
                                        <!-- Controlar cuándo mostrar el botón de expandir  -->
                                        <template v-slot:item.data-table-expand="{ item: detalleItem, internalItem, toggleExpand, isExpanded }">
                                            <v-btn
                                                v-if="detalleItem.mensajeRechazos && detalleItem.mensajeRechazos.trim() !== ''"
                                                :icon="isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi mdi-exclamation-thick'"
                                                size="small"
                                                color="red"
                                                @click="toggleExpand(internalItem)"
                                            />
                                        </template>
                                        <!-- 420101 -->
                                        <template v-if="item.codigoPractica == '420101'" v-slot:item.prescriptor="{ item: detalleItem}">
                                            <p>-</p>
                                        </template>
                                        <template v-else v-slot:item.prescriptor="{ item: detalleItem }">
                                            <p>{{ detalleItem.prescriptor.nombreApellidoPrescriptor }}</p>
                                            <p class="font-weight-light">{{ detalleItem.prescriptor.tipoMatriculaPrescriptor + " " + detalleItem.prescriptor.matriculaPrescriptor }}</p>
                                        </template>
                                        
                                        <template v-slot:item.estado="{ item: detalleItem }">
                                            <v-chip
                                                :color="estadosColores.find(e => e.nombre == detalleItem.estado) ? estadosColores.find(e => e.nombre == detalleItem.estado).color : 'grey'"
                                            >
                                                {{ estadosColores.find(e => e.nombre == detalleItem.estado) ? (estadosColores.find(e => e.nombre == detalleItem.estado).nombre != 'PorRealizar' ? estadosColores.find(e => e.nombre == detalleItem.estado).nombre : 'Aut. p/ realizar') : ' - ' }}
                                            </v-chip>
                                        </template>
                                        
                                        <!-- Contenido expandido con el mensaje de rechazo -->
                                        <template v-slot:expanded-row="{ columns, item: detalleItem }">
                                            <tr>
                                                <td :colspan="columns.length">
                                                    <div class="pa-4">
                                                        <v-alert
                                                            :text="detalleItem.mensajeRechazos"
                                                            title="Motivo de rechazo"
                                                            type="error"
                                                            color="red"
                                                            variant="tonal"
                                                            density="compact"
                                                            icon="mdi-close-circle"
                                                        ></v-alert>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <v-card-actions class="justify-end">
                                        <v-btn
                                            id="boton-verde"
                                            text="Cerrar"
                                            @click="isActive.value = false"
                                        ></v-btn>                                            
                                        <v-btn
                                            v-if="esIOMA(item.obraSocial.nombre) && esAdminFacturador() && item.esVersionNueva"                                            
                                            id="boton-verde"
                                            text="Consultar Valores (IOMA)"
                                            :disabled="puedeValorizar(item.detalle)"
                                            @click="obtenerValorizacionIOMA(item.id); isActive.value = false"
                                        ></v-btn>                                            
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>
                            <v-dialog
                                transition="dialog-top-transition"
                                width="auto"
                            >
                                <template v-slot:activator="{ props: activatorProps }">
                                    <v-list-item v-bind="activatorProps">
                                        <v-list-item-title>
                                            <v-icon>mdi mdi-account</v-icon>
                                            Detalle paciente
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card
                                    min-width="600">
                                        <v-toolbar title="Detalles adicionales del paciente" class="modal-header"></v-toolbar>
                                        <v-card-text>
                                            <v-row class="d-flex justify-space-between">
                                            <v-col cols="12" md="6">
                                                <p><b>Nombre y apellido:</b>{{ item.paciente.apellidoNombre }}</p>
                                                <p><b>Número de afiliado:</b> {{ item.afiliado.numeroafiliado }}</p>
                                                <p><b>Tipo afiliatorio:</b> {{ item.afiliado.tipoafiliado }}</p>
                                                <p><b>Plan afiliatorio:</b> {{ item.paciente.planAfiliatorio }}</p>
                                                <p><b>Sexo:</b> {{ item.paciente.sexo }}</p>
                                                <p><b>Tipo de documento:</b> {{ item.paciente.tipoDocumento }}</p>
                                                <p><b>Número de documento:</b> {{ item.paciente.numeroDocumento }}</p>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <p><b>Dirección:</b> {{ item.paciente.direccion }}</p>
                                                <p><b>Teléfono:</b> {{ item.paciente.telefono }}</p>
                                                <p><b>Email:</b> {{ item.paciente.email }}</p>
                                                <p><b>Vencimiento carnet del afiliado:</b>{{ item.paciente.vencimientoCarnet.toString().split('T')[0] }}</p>
                                                <p><b>Archivos carnet:</b>
                                                    <ImageModal
                                                        v-if="item.paciente.carnetAfiliatorio"
                                                        :archivos="item.paciente.carnetAfiliatorio"
                                                        :detalle="[]"
                                                        :tiposDocumentacion="tiposDocumentacion"
                                                        :mostrarAcciones="false"
                                                        :headerText="'Carnet del afiliado'"
                                                        :typeButton="true"
                                                        :estadoSolicitud="item.estado"
                                                    ></ImageModal>
                                                </p>
                                            </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-actions class="justify-end">
                                            <v-btn
                                                id="boton-verde"
                                                text="Cerrar"
                                                @click="isActive.value = false"
                                            ></v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>
                        <AgregarImagenes
                            v-if="puedeAdjuntarArchivos(item)"
                            :detalle="item.detalle"
                            :idSolicitud="item.id"
                            @archivos-agregados="archivosAgregados"
                            :tiposDocumentacion="getTiposDocParaCarga(item.esBonoAdicional ? 'bono-adicional' : item.esPracticaPesada ? 'practica-pesada' : 'normal', item.obraSocial.nombre, item.esVersionNueva)"
                        ></AgregarImagenes>
                        <v-list-item @click="generarPDF(item.id)" v-if="!(esAuditor() || esAuditorGeneral())">
                            <v-list-item-title>
                                <v-icon>mdi mdi-printer</v-icon>
                                Descargar en PDF
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table-server>
    </v-card>
    </v-container>
    <ModalModificarEfector
        v-model="modalModificarEfector"
        :idSolicitud="idSolicitudAModificar"
        :efectorActual="efectorActualSolicitud"
        :profesionalesFacturador="profesionalesFacturador"
        :cargandoEfector="cargandoEfector"
        @enviar="handleModificarEfector"
    />
    <ModalEnviarARealizar
        v-model="modalEnviarARealizar"
        :idSolicitud="idSolicitudARealizar"
        :efectorActual="efectorActualSolicitud"
        :profesionalesFacturador="profesionalesFacturador"
        :cargandoEfector="cargandoEfector"
        @enviar="handleEnviarARealizar"
    />     
</template>